"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _default = _react.default.createClass({
  displayName: "UITypeaheadResults",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    children: _react.PropTypes.node,
    onScroll: _react.PropTypes.func
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        onScroll = _this$props.onScroll,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "onScroll"]);
    return _react.default.createElement("ul", (0, _extends2.default)({}, rest, {
      className: (0, _classNames.default)('private-typeahead-results', className),
      onScroll: onScroll,
      role: "listbox"
    }), children);
  }
});

exports.default = _default;
module.exports = exports.default;